/**
 * Creates a validator function that checks each property in an `object` against a provided schema.
 * @typeparam T The type of the `object`.
 * @param schema The schema that the `object` will be checked against.
 */
export const validateSchema = (schema) => {
    return (value, logger, logLabel) => {
        const schemaKeys = Object.keys(schema);
        return Object.keys(value).every(key => {
            const propertyLogLabel = `${logLabel}.${key}`;
            if (!schemaKeys.includes(key)) {
                logger(`${propertyLogLabel} not expected.`);
                return false;
            }
            const propertyValidator = schema[key];
            const propertyValue = value[key];
            return propertyValidator(propertyValue, logger, propertyLogLabel);
        });
    };
};
//# sourceMappingURL=schema.js.map